import base32 from 'base32.js'

export function randomId(length = 18) {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16))
  const encoder = new base32.Encoder()
  const token = encoder.write(bytes).finalize()
  return token.replace(/=+$/, '').slice(0, length)
}

export function generateObjectId() {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16)
  const randomBytes = Array.from({ length: 16 }, () =>
    Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0')
  ).join('')

  return timestamp + randomBytes.substring(0, 16)
}
